import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { find, sortBy } from 'lodash-es';

import cn from 'classnames';
import stylePropType from 'react-style-proptype';

import * as types from './StepNavMenu.actionTypes';
import { StateEnum } from './StepNavMenu.enum';
import reducer from './StepNavMenu.reducer';
import { entryShape } from './StepNavMenu.shape';
import { initializeState } from './StepNavMenu.transform';
import useReducer from '../../Utils/useReducer';
import { getLabel } from '../../Utils/utils';

import './StepNavMenu.scss';

const StepNavMenu = ({ data, eventEmitter, strings /* , style */ }) => {
  const initialState = initializeState({ data });
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({
      type: types.UPDATE,
      data: { menu: data },
    });
  }, [data]);

  useEffect(() => {
    // Add noDispatch to not dispatch an event if state have been updated from props
    if (!state.noDispatch) {
      const obj = find(state.menu, { state: StateEnum.CURRENT });

      if (obj) eventEmitter(obj);
    }
  }, [state]);

  /**
   * Handle click event
   * @param {number} id
   */
  const handleClick = ({ id }) => {
    const obj = find(state.menu, { state: StateEnum.CURRENT });

    if (!obj || (obj && obj.id !== id)) {
      dispatch({
        type: types.SET_CURRENT,
        id,
      });
    }
  };

  return (
    <div className="stepnavmenu">
      {sortBy(state.menu, 'sequence').map(({ label, id, state: menuState, menuLabel }) => (
        <div
          className={cn('stepnav', {
            enabled: menuState === StateEnum.ENABLED,
            disabled: menuState === StateEnum.DISABLED,
            current: menuState === StateEnum.CURRENT,
          })}
          key={`stepnav-${id}`}
        >
          <i
            className={cn({
              arrow: true,
              right: menuState === StateEnum.CURRENT,
              hidden: menuState !== StateEnum.CURRENT,
            })}
          />
          {menuState === StateEnum.DISABLED ? (
            <span className="label">
              <span>
                {getLabel({
                  label: menuLabel || label,
                  strings,
                  defaultCode: `menu.label.${label}`,
                })}
              </span>
            </span>
          ) : (
            <span
              className="label"
              onClick={() => handleClick({ id })}
              onKeyPress={() => handleClick({ id })}
              role="link"
              tabIndex={0}
            >
              <span>
                {getLabel({
                  label: menuLabel || label,
                  strings,
                  defaultCode: `menu.label.${label}`,
                })}
              </span>
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

StepNavMenu.propTypes = {
  data: PropTypes.arrayOf(entryShape).isRequired,
  eventEmitter: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  style: stylePropType,
};

StepNavMenu.defaultProps = {
  strings: {},
  style: { minWidth: '250px' },
};

export default StepNavMenu;
